var map = {
	"./blackjack_en.png": "aaMT",
	"./blackjack_th.png": "9F6t"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gtR7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa ^\.\/blackjack_.*\.png$
// module id = gtR7
// module chunks = 1